import React from 'react';
import { omit, has, set, get, unset, isArray } from 'lodash';
import WarehousesSection from './components/WarehousesSection';

const CUSTOM_DETAILS_QUERY_FIELD = 'assignedWarehouses {id, label }';

const customVendorForm = (app) => {
    const formRoute = app.routes.getItem('vendorForm');
    if (formRoute) {
        const routeProps = formRoute.props;

        const getCustomFormPayload = (data, values) => {
            const { assignedWarehouses = [] } = values;
            set(data, 'warehouse_assignment', assignedWarehouses);
            return omit(data, ['assignedWarehouses']);
        };

        const customFormProps = (props) => {
            const { initialValues = {}, validationSchema = {} } = props;
            return {
                ...props,
                initialValues: {
                    ...initialValues,
                    assignedWarehouses: [],
                },
                validationSchema: {
                    ...validationSchema,
                    assignedWarehouses: {
                        type: 'array',
                        validations: [{ type: 'min', params: [1] }, 'required'],
                    },
                },
            };
        };

        formRoute.props = (state) => ({
            ...routeProps(state),
            getCustomFormPayload,
            customFormSection: WarehousesSection,
            customFormProps,
            customGraphqlFields: {
                details: CUSTOM_DETAILS_QUERY_FIELD,
            },
        });

        app.routes.changeItem('vendorForm', formRoute);
    }
};

const customVendorDetails = (app) => {
    const formRoute = app.routes.getItem('vendorOverview');
    if (formRoute) {
        const routeProps = formRoute.props;

        const getInfoAttributesConfig = (leftAttributes, rightAttributes) => ({
            leftAttributesConfig: leftAttributes,
            rightAttributesConfig: {
                ...rightAttributes,
                assignedWarehouses: {
                    label: 'Assigned Warehouses',
                    key: 'assignedWarehouses',
                    component: ({ data: warehouses }) => (
                        <ul className="pl-3 m-0">
                            {warehouses.map(({ label }) => (
                                <li>{label}</li>
                            ))}
                        </ul>
                    ),
                },
            },
        });

        formRoute.props = (state) => ({
            ...routeProps(state),
            getInfoAttributesConfig,
            customGraphqlFields: {
                details: CUSTOM_DETAILS_QUERY_FIELD,
            },
        });

        app.routes.changeItem('vendorOverview', formRoute);
    }
};

export default {
    name: 'assignWarehousesToVendorConfig',
    before: [],
    after: [],
    setup: (app) => {
        customVendorForm(app);
        customVendorDetails(app);
    },
};
